import type { UserStatus } from '@psp-aggregator/sdk';

export type UserStatusLabelKey =
  | 'status.pending'
  | 'status.active'
  | 'status.blocked'
  | 'status.inactive'
  | 'status.rejected';

export type UserStatusBadgeVariant =
  'warning' | 'success' | 'destructive' | 'secondary';

export const USER_STATUS_I18N_KEY: Record<UserStatus, UserStatusLabelKey> = {
  active: 'status.active',
  blocked: 'status.blocked',
  inactive: 'status.inactive',
  pending: 'status.pending',
  rejected: 'status.rejected',
};

export const USER_STATUS_BADGE_VARIANT: Record<
  UserStatus,
  UserStatusBadgeVariant
> = {
  active: 'success',
  blocked: 'destructive',
  inactive: 'secondary',
  pending: 'warning',
  rejected: 'destructive',
};

export const USER_STATUS_FILTER_OPTIONS: readonly UserStatus[] = [
  'pending',
  'active',
  'blocked',
  'inactive',
  'rejected',
] as const;
